import { isSerializedClientError } from "../types/SerializedClientError"

const PII_KEYS = new Set(["iban", "accountHolder", "line1"])

function redactPiiKeys(value: unknown): unknown {
    if (Array.isArray(value)) return value.map(redactPiiKeys)

    if (typeof value === "object" && value !== null) {
        return Object.fromEntries(
            Object.entries(value as Record<string, unknown>).map(([key, nestedValue]) => [
                key,
                PII_KEYS.has(key) ? "[REDACTED]" : redactPiiKeys(nestedValue),
            ])
        )
    }

    return value
}

// The RUM SDK serialises the full ClientError (including request.variables with
// PII: IBAN, names, address…) into error.stack on network errors.
// Redact known PII keys recursively so the structure stays visible for debugging.
export function obfuscateGraphqlVariables(stack: string): string {
    try {
        const parsed: unknown = JSON.parse(stack)

        if (isSerializedClientError(parsed) && parsed.request.variables !== undefined) {
            parsed.request.variables = redactPiiKeys(parsed.request.variables)

            return JSON.stringify(parsed)
        }
    } catch {
        // not a serialised ClientError — leave stack untouched
    }

    return stack
}
